var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google/add_circle_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66732 7.34717H7.33398H4.66732V8.6805H7.33398H8.66732H11.334V7.34717H8.66732ZM8.00065 1.34717C4.32065 1.34717 1.33398 4.33383 1.33398 8.01383C1.33398 11.6938 4.32065 14.6805 8.00065 14.6805C11.6807 14.6805 14.6673 11.6938 14.6673 8.01383C14.6673 4.33383 11.6807 1.34717 8.00065 1.34717ZM8.00065 13.3472C5.06065 13.3472 2.66732 10.9538 2.66732 8.01383C2.66732 5.07383 5.06065 2.6805 8.00065 2.6805C10.9407 2.6805 13.334 5.07383 13.334 8.01383C13.334 10.9538 10.9407 13.3472 8.00065 13.3472Z",
    fill: "#16BAB6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.dc5c454b.svg";
export { ForwardRef as ReactComponent };